export const LOAD_USER_AGENCIES_SUCCESS = "LOAD_USER_AGENCIES_SUCCESS";
export const LOAD_USER_PROFILE_SUCCESS = "LOAD_USER_PROFILE_SUCCESS";
export const CLEAR_USER_PROFILE = "CLEAR_USER_PROFILE";
export const OPEN_USER_PROFILE_CONFIRMATION_DIALOG =
  "OPEN_USER_PROFILE_CONFIRMATION_DIALOG";
export const CLOSE_USER_PROFILE_CONFIRMATION_DIALOG =
  "CLOSE_USER_PROFILE_CONFIRMATION_DIALOG";
export const USER_MODEL_ID = "userId";
